import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './component/atoms/icon/icon.component';
import { ListitemComponent } from './component/organisms/listitem/listitem.component';
import { TimesearchComponent } from './component/molecules/timesearch/timesearch.component';
import { NgzorroModule } from './ngzorro/ngzorro.module';
import { UnitSignedComponent } from '../pages/main/module/invoices-signed/components/unit-signed-config/unit-signed/unit-signed.component';
import { PaginationComponent } from './component/atoms/pagination/pagination.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEchartsModule } from 'ngx-echarts';
import { TranslateModule } from '@ngx-translate/core';
import { EditFormInlineComponent } from './component/molecules/edit-form-inline/edit-form-inline.component';
import { PreviewUploadComponent } from './component/molecules/preview-upload/preview-upload.component';
import { SimpleTableComponent } from './component/molecules/simple-table/simple-table.component';
import { UploadFileComponent } from './component/molecules/upload-file/upload-file.component';


@NgModule({
  declarations: [
    IconComponent,
    ListitemComponent,
    TimesearchComponent,
    UnitSignedComponent,
    PaginationComponent,
    SimpleTableComponent,
    EditFormInlineComponent,
    UploadFileComponent,
    PreviewUploadComponent,
  ],
  imports: [
    CommonModule,
    NgzorroModule,
    ReactiveFormsModule,
    FormsModule,
    NgxEchartsModule.forRoot({ echarts: () => import("echarts"), }),
    TranslateModule
  ],
  exports: [
    NgzorroModule,
    IconComponent,
    ListitemComponent,
    TimesearchComponent,
    PaginationComponent,
    FormsModule,
    SimpleTableComponent,
    EditFormInlineComponent,
    ReactiveFormsModule,
    PreviewUploadComponent,
    NgxEchartsModule,
    UploadFileComponent,
    TranslateModule,
  ],
  providers: [],
})
export class SharedModule {
}
